import { APPLICATION_OFFER_TYPE_NAME, ENROLMENT_TYPE } from '@/constants'

export function getEnrolmentType(application) {
  const {
    MEO_SHS,
    MEO_SCT,
    MEO_MAIN,
    SHS_OFFER,
    SCT_OFFER,
    SCE_OFFER,
    OUT_OF_AREA_OFFER,
    Y67T_OFFER,
    LOCAL_AREA_OFFER,
    MEO_FDIS,
    MEO_DEC
  } = APPLICATION_OFFER_TYPE_NAME

  const {
    enrolmentType,
    isMEOOffer,
    ooaApplicationNo,
    ooaApplicationID,
    inArea,
    isInArea,
    eoiID,
    shsOfferId
  } = application

  // Check based on enrolmentType if available
  if (enrolmentType) {
    if (enrolmentType === ENROLMENT_TYPE.SHS) {
      return isMEOOffer ? MEO_SHS : SHS_OFFER
    }

    if (enrolmentType === ENROLMENT_TYPE.SCT) {
      return isMEOOffer ? MEO_SCT : SCT_OFFER
    }

    if (enrolmentType === ENROLMENT_TYPE.SCE) {
      return SCE_OFFER
    }
    if (enrolmentType === ENROLMENT_TYPE.FDIS) {
      return MEO_FDIS
    }
    if (enrolmentType === ENROLMENT_TYPE.DEC) {
      return MEO_DEC
    }
  }

  // Check for out of area offer
  if (isMEOOffer && (inArea === false || isInArea === false)) {
    return MEO_MAIN
  }

  if (
    (ooaApplicationNo && ooaApplicationNo.length > 0) ||
    (ooaApplicationID && ooaApplicationID.length > 0)
  ) {
    return OUT_OF_AREA_OFFER
  }

  // Check for Y67T offer
  if (eoiID && eoiID.length > 0) {
    return Y67T_OFFER
  }

  // Check for SHS offer based on shsOfferId
  if (shsOfferId && shsOfferId.length > 0) {
    return SHS_OFFER
  }

  // Default case
  return isMEOOffer ? MEO_MAIN : LOCAL_AREA_OFFER
}
